import MainAnalyticsReport from "../components/analytics-report/main-analytics";

function AnalyticsReports() {
  return (
    <div className="w-[95%] mx-auto">
        
      <MainAnalyticsReport />
    </div>
  );
}

export default AnalyticsReports;